import { useCallback } from 'react';
import {
  SelectLabelOption,
  useUpdateCustomLabelOptionsMutation
} from 'graphql/types';

type UpdateCustomLabelOptionArgs = {
  updateName: string;
  id: string;
  customLabelId: string;
};
type UpdateCustomLabelOptionsReturn = {
  loading: boolean;
  updateCustomLabelOptions: (
    args: UpdateCustomLabelOptionArgs
  ) => Promise<SelectLabelOption | undefined>;
};
export const useUpdateCustomLabelOptions = (
  onComplete?: () => void
): UpdateCustomLabelOptionsReturn => {
  const [
    updateCustomLabelOptionsMutation,
    { loading }
  ] = useUpdateCustomLabelOptionsMutation();

  const updateCustomLabelOptions = useCallback(
    async ({ id, updateName, customLabelId }: UpdateCustomLabelOptionArgs) => {
      const result = await updateCustomLabelOptionsMutation({
        variables: {
          input: {
            updateOptions: [
              {
                id,
                name: updateName,
                customLabelId
              }
            ]
          }
        },
        refetchQueries: ['selectLabelOptions'],
        awaitRefetchQueries: true
      });
      onComplete?.();
      return result.data?.updateCustomLabelOptions.customLabelOptions[0];
    },
    [updateCustomLabelOptionsMutation, onComplete]
  );

  return { loading, updateCustomLabelOptions };
};
